/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getLayersOverrides';
import type { GetLayersQueryParams } from '../../operation-overrides/getLayersOverrides';

export type GetLayersPathParams = NonNullable<operations['getLayers']['parameters']['path']>;
export type { GetLayersQueryParams };

export interface Input extends GetLayersPathParams {
  apiVersion?: string;
  query?: GetLayersQueryParams;
}

export async function getLayers(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/layers', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
